import { CtaButtons } from '@/components/CTAButtons';
import { SignupForm } from '@/components/SignupForm';
import { useRef } from 'react';
import './styles.scss';

interface CTASectionProps {
  signupFormRef: React.RefObject<HTMLDivElement | null>;
  inputRef: React.RefObject<HTMLInputElement | null>;
  onGetTheDeckClick: () => void;
}

export const CTASection = ({
  signupFormRef,
  inputRef,
  onGetTheDeckClick,
}: CTASectionProps) => {
  const ctaButtonsRef = useRef<HTMLDivElement>(null);

  return (
    <section className='cta-section'>
      <img
        className='particle particle-4 desktop-only'
        src='cta-section/particle4-desktop.webp'
        alt='Green Particle'
      />
      <img
        src='cta-section/background-mobile.webp'
        alt='green wave'
        className='cta-background mobile-only'
      />

      <div className='container gif-container'>
        <div className=''>
          <img
            src='cta-section/animation.gif'
            alt='PlayWall Logo Animation'
            className='logo-animation'
          />
          <span className='text'>
            Malaysia's first interactive OOH network. <br /> On
            {String.fromCharCode(8209)}ground . Measurable. Finally!
          </span>
        </div>
      </div>

      <div className='container contact-container'>
        <div ref={signupFormRef} id='signup' className='contact'>
          <img
            src='cta-section/particle1.webp'
            alt='green particle'
            className='particle particle-1'
          />
          <img
            src='cta-section/particle2.webp'
            alt='green particle'
            className='particle particle-2'
          />
          <img
            className='particle particle-3 desktop-only'
            src='cta-section/particle3-desktop.webp'
            alt='Green Particle'
          />

          <div className='content-wrapper'>
            <div>
              <div className='text-1'>
                Early Adopter <span>rates only until June 2026.</span>
              </div>
              <div className='text-2'>Blink and they're gone.</div>
              <div className='text-3'>
                Drop your email and we'll send you the PlayWall Early Adopter
                Deck — proof that on{String.fromCharCode(8209)}ground can
                perform like digital.
              </div>
            </div>

            <SignupForm inputRef={inputRef} />
          </div>
        </div>
      </div>

      <div ref={ctaButtonsRef} className='container buttons-container'>
        <CtaButtons
          positionRef={ctaButtonsRef}
          onGetTheDeckClick={onGetTheDeckClick}
        />
      </div>
    </section>
  );
};
